/**
 * The integration types that are currently allowed in the UI.
 * Add new types here as they become supported.
 */
export const ALLOWED_INTEGRATION_TYPES = ["AWSPlatform"] as const;

export type AllowedIntegrationType = (typeof ALLOWED_INTEGRATION_TYPES)[number];

export function isAllowedIntegrationType(
  typeName: string,
): typeName is AllowedIntegrationType {
  return (ALLOWED_INTEGRATION_TYPES as readonly string[]).includes(typeName);
}
